import { depthLabel, retentionByDepth } from '@/common/app/modules/media/queryFanout'
import { DepthAnalysisItem, RetentionChartItem } from '@/common/model/media/queryFanout'

import Badge, { BadgeType } from '@/components/view/atoms/badge/Badge'
import TableHeadItem from '@/components/view/atoms/table/TableHeadItem'
import TableRow from '@/components/view/atoms/table/TableRow'
import TableRowItem from '@/components/view/atoms/table/TableRowItem'
import Text, { TextColor } from '@/components/view/atoms/text/Text'

interface Props {
  depthAnalysis: DepthAnalysisItem[]
  // 深度ごとの競合／自社ブランド数の併記に使う
  retentionChart: RetentionChartItem[]
}

// 各深度での自社ブランドの言及状況テーブル
const QueryFanoutDepthTable = ({ depthAnalysis, retentionChart }: Props) => {
  const retention = retentionByDepth(retentionChart)

  return (
    <table className='w-full border-collapse'>
      <thead>
        <TableRow head>
          <TableHeadItem type='thin'>
            <Text size={12} color={TextColor.SECONDARY}>
              深度
            </Text>
          </TableHeadItem>
          <TableHeadItem type='thin' width={88}>
            <Text size={12} color={TextColor.SECONDARY}>
              言及有無
            </Text>
          </TableHeadItem>
          <TableHeadItem type='thin' width={64}>
            <Text size={12} color={TextColor.SECONDARY}>
              順位
            </Text>
          </TableHeadItem>
          <TableHeadItem type='thin' width={128}>
            <Text size={12} color={TextColor.SECONDARY}>
              競合/自社ブランド数
            </Text>
          </TableHeadItem>
        </TableRow>
      </thead>
      <tbody>
        {depthAnalysis.map((d, i) => {
          const r = retention[d.depth]
          return (
            <TableRow key={i}>
              <TableRowItem align='middle'>
                <Text size={14}>{depthLabel(d.depth)}</Text>
              </TableRowItem>
              <TableRowItem width={88} align='middle'>
                <Badge size={10} badgeType={d.mentioned ? BadgeType.SUCCESS : BadgeType.CRITICAL}>
                  {d.mentioned ? '言及あり' : '言及なし'}
                </Badge>
              </TableRowItem>
              <TableRowItem width={64} align='middle'>
                <Text size={14} color={d.position ? TextColor.PRIMARY : TextColor.PLACEHOLDER}>
                  {d.position ? d.position : '-'}
                </Text>
              </TableRowItem>
              <TableRowItem width={128} align='middle'>
                <Text size={14}>
                  {r ? `${r.competitors_count ?? 0}/${r.own_brand ? 1 : 0}` : '-'}
                </Text>
              </TableRowItem>
            </TableRow>
          )
        })}
      </tbody>
    </table>
  )
}

export default QueryFanoutDepthTable
